import React,{ useState } from 'react';

import Card from '../../shared/components/UIElements/Card';
import Button from '../../shared/components/FormElements/Button/Button';
import Input from '../../shared/components/FormElements/Input/Input';
import ErrorModal from '../../shared/components/UIElements/ErrorModal';
import LoadingSpinner from '../../shared/components/UIElements/LoadingSpinner';
import { useHttpClient } from '../../shared/hooks/http-hook';
import {
    VALIDATOR_EMAIL
  } from '../../shared/util/validator';
import { useForm } from '../../shared/hooks/form-hook';
import './Auth.css';

const ResetPassword = () => {
    const [emailSent, setEmailSent] = useState(false);
    const {isLoading, error, sendRequest, clearError} = useHttpClient();
    const [formState, inputHandler] = useForm(
        {
          email: {
            value: '',
            isValid: false
          }
        },
        false
      );

      const emailSubmitHandler = async(event) => {
        event.preventDefault();

        const responseData = await sendRequest(process.env.REACT_APP_BACKEND_URL_USER+'/reset', 'POST',
        JSON.stringify({
            email: formState.inputs.email.value
        }),
        {
            'Content-Type': 'application/json'
        }
        );

        if (responseData.email) {
          setEmailSent(true);
        }
    };

    if (emailSent) {
        return <div className='thank-you-message'>
            <h3>Email has been sent to your email address. Click the link in the email to reset your password.</h3>
        </div>
    };

    return <React.Fragment>
        <ErrorModal error={error} onClear={clearError}/>
        <div className='loginpage-container'>
        {isLoading && <LoadingSpinner asOverlay />}
        <div className='vaceai-auth'>VACE.AI</div>
        <Card className="authentication">
          <h3>Reset Your Password</h3>
          <hr />
          <form onSubmit={emailSubmitHandler}>
            <Input
                element="input"
                id="email"
                type="email"
                label="Email Address"
                validators={[VALIDATOR_EMAIL()]}
                errorText="Please enter your email"
                onInput={inputHandler}
            />
            <div className="authentication-button-submit">
              <div className='submit-button'>
                <Button type="submit" disabled={!formState.isValid} transparent>
                  <p style={{ color: 'white', marginBottom: 0, marginTop: 0 }}>Send</p>
                </Button>
              </div>
            </div>
          </form>
        </Card>
        </div>
    </React.Fragment>

};

export default ResetPassword;